import { isPlainObject } from 'lodash-es';

export const deepCopy = <T>(obj: T): T => structuredClone(obj);

export const isEmpty = (v: unknown): boolean => {
  if (v === null) {
    return true;
  }
  if (typeof v === 'undefined') {
    return true;
  }
  if (typeof v === 'string' && v === '') {
    return true;
  }
  if (Array.isArray(v) && v.length < 1) {
    return true;
  }
  if (
    typeof v === 'object' &&
    v.constructor.name === 'Object' &&
    Object.keys(v).length < 1 &&
    Object.getOwnPropertyNames(v).length < 1
  ) {
    return true;
  }
  if (
    typeof v === 'object' &&
    v.constructor.name === 'String' &&
    Object.keys(v).length < 1
  ) {
    return true;
  }
  return false;
};

export const mergeObject = <T extends Dictionary>(
  target: T,
  src: Nullish<Partial<T>>,
): T => {
  if (src == null) return { ...target };

  const result = { ...target };

  Object.entries(target).forEach(([k, v]) => {
    const sv = src[k];

    isPlainObject(v) && isPlainObject(sv)
      ? (result[k as keyof T] = mergeObject(v, sv))
      : sv !== undefined
        ? (result[k as keyof T] = sv)
        : void 0;
  });

  Object.entries(src).forEach(([k, v]) => {
    !(k in target) && v !== undefined && (result[k as keyof T] = v);
  });

  return result;
};
